import Vue from 'vue'
import App from './App'
import router from './router/index.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VeLine from 'v-charts/lib/line'
import VeBar from 'v-charts/lib/bar'
import 'v-charts/lib/style.css'
import VueWechatTitle from 'vue-wechat-title';

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(VueWechatTitle)

Vue.component('ve-line', VeLine)
Vue.component('ve-bar', VeBar)

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js